import {makeStore} from "./make_store";

export const store = makeStore({});
import {makeStore} from "./make_store";

export const store = makeStore({});
